// extracted by mini-css-extract-plugin
export default {"sideBar":"style_sideBar__80EFf","content":"style_content__jB0XW"};